import PickyEaterPopupActivated from './PickyEaterPopupActivated'
import PickyEaterPopupCTAClicked from './PickyEaterPopupCTAClicked'
import PageViewed from "~/models/Events/PageViewed.js";
import InitializedCheckout from "~/models/Events/InitializedCheckout.js";

export default [new PickyEaterPopupActivated(), new PickyEaterPopupCTAClicked(), new PageViewed(), new InitializedCheckout()]
